const FeaturesShowcase = () => {
  const features = [
    {
      icon: "🎯",
      title: "Precision Gaming",
      description:
        "Experience games with stunning graphics and smooth performance",
    },
    {
      icon: "⚡",
      title: "Lightning Fast",
      description: "Instant downloads and updates for uninterrupted gaming",
    },
    {
      icon: "🛡️",
      title: "Secure Platform",
      description: "Bank-level security for all transactions and personal data",
    },
    {
      icon: "🌟",
      title: "Exclusive Deals",
      description: "Access to limited-time offers and member-only discounts",
    },
    {
      icon: "🎮",
      title: "Cross-Platform",
      description: "Play on any device with seamless cloud synchronization",
    },
    {
      icon: "👥",
      title: "Community Driven",
      description: "Join thousands of gamers in our active community forums",
    },
  ];

  return (
    <section className="mb-20">
      <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
        Why Choose GamesHub?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-8 shadow-lg hover:shadow-xl transition duration-300 transform hover:-translate-y-2 border border-gray-100"
          >
            <div className="text-5xl mb-4">{feature.icon}</div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              {feature.title}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesShowcase;
